import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EVERAPP
})
const ACCESS_TOKEN_PARAM = 'access_token'
const ACCESS_TOKEN_STORAGE_KEY = 'token'

instance.interceptors.request.use(config => {
  const jwt = typeof localStorage !== 'undefined'
    ? localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY)
    : null
  if (jwt && !(config.params && config.params[ACCESS_TOKEN_PARAM])) {
    return {
      ...config,
      params: {
        ...(config.params || {}),
        [ACCESS_TOKEN_PARAM]: jwt
      }
    }
  }
  return config
})

function setJwt(jwt) {
  if (jwt) {
    instance.defaults.params = {}
    instance.defaults.params[ACCESS_TOKEN_PARAM] = jwt
  }
}

function clearJwt() {
  if (instance.defaults.params) {
    delete instance.defaults.params
  }
}

export default {
  get: instance.get,
  post: instance.post,
  put: instance.put,
  delete: instance.delete,
  patch: instance.patch,
  setJwt,
  clearJwt
}
